module.exports = {
          srcSet: __webpack_public_path__ + "bc7669da.jpg"+" 330w",
          images:[ {path: __webpack_public_path__ + "bc7669da.jpg",width: 330,height: 200}],
          src: __webpack_public_path__ + "bc7669da.jpg",
          toString:function(){return __webpack_public_path__ + "bc7669da.jpg"},
          
          width: 330,
          height: 200
        }